<template>
	<b-modal
		centered
		no-close-on-backdrop
		size="xmd"
		title="REGISTRAR MUERTOS"
		v-model="isActive"
		@hidden="handleHidden"
	>
		<b-overlay :show="isLoading">
			<b-tabs lazy v-model="tab">
				<b-tab title="Cintillos en pata" />
				<b-tab title="Cintillos en ala" />
				<b-tab title="Ejemplares" />
			</b-tabs>
			<div class="d-flex justify-content-between align-items-center">
				<div class="font-weight-bolder">Crear Registro</div>
				<b-button @click="showList(tab + 1)" variant="gradient-primary">Ver Historial</b-button>
			</div>
			<component v-bind:is="curForm" :saveTrigger="saveTrigger" @loading="($event) => (isLoading = $event)" />
		</b-overlay>
		<template #modal-footer>
			<b-button variant="success" @click="useTrigger" :disabled="isLoading">Guardar</b-button>
		</template>
		<ListPataModal :show="listPatas.show" @closing="listPatas.show = false" />
		<ListAlaModal :show="listAlas.show" @closing="listAlas.show = false" />
		<ListSpecimenModal :show="listSpecimens.show" @closing="listSpecimens.show = false" />
	</b-modal>
</template>

<script>
import InsertDeadPata from "./InsertDeadPata.vue"
import InsertDeadAla from "./InsertDeadAla.vue"
import InsertDeadSpecimen from "./InsertDeadSpecimen.vue"

import ListPataModal from "./ListPataModal.vue"
import ListAlaModal from "./ListAlaModal.vue"
import ListSpecimenModal from "./ListSpecimenModal.vue"

export default {
	components: { ListPataModal, ListAlaModal, ListSpecimenModal, InsertDeadPata, InsertDeadAla, InsertDeadSpecimen },
	props: {
		show: Boolean,
	},
	data: () => ({
		isActive: false,
		isLoading: false,
		tab: 0,
		saveTrigger: Symbol(),
		listPatas: { show: false },
		listAlas: { show: false },
		listSpecimens: { show: false },
	}),
	computed: {
		curForm() {
			switch (this.tab) {
				case 0:
					return "InsertDeadPata"
				case 1:
					return "InsertDeadAla"
				case 2:
					return "InsertDeadSpecimen"
				default:
					return ""
			}
		},
	},
	methods: {
		handleHidden() {
			this.isActive = false
			this.isLoading = false
			this.tab = 0
			this.$emit("closing")
		},
		showList(type) {
			switch (type) {
				case 1:
					this.listPatas.show = !this.listPatas.show
					break
				case 2:
					this.listAlas.show = !this.listAlas.show
					break
				case 3:
					this.listSpecimens.show = !this.listSpecimens.show
					break
			}
		},
		useTrigger() {
			this.saveTrigger = Symbol()
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.isActive = val
			}
		},
	},
}
</script>
